// Helper function to get prompting structure
export const getPromptingStructure = (type) => {
  if (type === 'P+ & P-') {
    return { pMinus: '', pPlus: '' };
  } else if (type === 'IVP, DVP, PVP, GP, PP') {
    return { I: '', VP: '', IVP: '', DVP: '', PVP: '', GP: '', PP: '' };
  }
  return {};
};

export default getPromptingStructure;


